import React, { Fragment, Component, useState } from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';
import { StylesMedia, ThumbnailBroken, Thumbnail, ThumbnailCounter, Text, ThumbnailLoadingContainer, ThumbnailInactiveContainer, Grid, Checkbox, PageListItem, PageListLayout, icons, PreviewLayout, FieldLayerLayout, ProgressBar, InfiniteProgress, Button, UploadingDocumentProgress, Tabs } from '@pdffiller/pdf-viewer-ui';
import classNames from 'classnames';
import { Page, Documents, Document, DocumentsContext } from '@pdffiller/pdf-viewer-core';
import throttle from 'lodash.throttle';
import Input from '@pdffiller/export-ui/lib/ui/Input';
import Checkbox$1 from '@pdffiller/export-ui/lib/ui/Checkbox';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var constants = {
  LIST_PAGE_LABEL: 'Page',
  PREVIOUS_PAGE_CONTROL_TEXT: 'Show previous page',
  EDIT_PAGE_CONTROL_TEXT: 'Edit Page',
  NEXT_PAGE_CONTROL_TEXT: 'Show next page',
  PREVIEW_CONTROL_TEXT: 'Preview',
  SELECT_PAGES_CONTROL_TEXT: 'Select Pages',
  LOADING_TEXT: 'Loading',
  EXCLUDED_PAGE_THUMBNAIL_TEXT: 'Excluded',
  NO_ONE_SELECTED_PAGE_TEXT: 'Please, select at least one page to see the preview',
  NOT_AVAILABLE_PAGE_PREVIEW_TEXT: 'Preview is not available for this document',
  GETTING_DOCUMENT_READY_TEXT: 'Getting Your Document Ready!'
};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "._2CrqF{align-items:flex-start}._1EGEZ{align-items:center}.hfS2F{align-items:flex-end}._3VvAP{justify-content:flex-start}._2_6C7{justify-content:center}._28Jsi{justify-content:flex-end}.Dvqra{justify-content:space-between}._2G1nr{flex-grow:0}._1Ji62{flex-grow:1}._2PPBa{flex-shrink:0}._2GGyF{flex-shrink:1}._35-AQ{padding-top:.125em!important}._3RPRq{padding-top:.25em!important}._1pEbe{padding-top:.375em!important}._23W76{padding-top:.5em!important}._1Jgne{padding-top:.625em!important}._3jC8l{padding-top:.75em!important}._2nRV-{padding-top:.875em!important}._2lnbD{padding-right:.125em!important}._2rQlz{padding-right:.25em!important}.OUTnI{padding-right:.375em!important}._2ulSe{padding-right:.5em!important}._1rxy2{padding-right:.625em!important}.Utljf{padding-right:.75em!important}._2CtgS{padding-right:.875em!important}.sy1Dh{padding-bottom:.125em!important}._3T1we{padding-bottom:.25em!important}._2vM-g{padding-bottom:.375em!important}.uWtMV{padding-bottom:.5em!important}.mXIFD{padding-bottom:.625em!important}._29SIx{padding-bottom:.75em!important}._2uDY{padding-bottom:.875em!important}.EozXW{padding-left:.125em!important}.G1rfC{padding-left:.25em!important}._539Q6{padding-left:.375em!important}.VyH4H{padding-left:.5em!important}._3bL4m{padding-left:.625em!important}._1s5SS{padding-left:.75em!important}._5-zEv{padding-left:.875em!important}._2kg14{padding:.125em!important}._1wTNV{padding:.25em!important}._2JwXf{padding:.375em!important}.eatEE{padding:.5em!important}.NdOVG{padding:.625em!important}._dQqM{padding:.75em!important}._1N-3h{padding:.875em!important}._3sx6H{border-radius:999em!important}._SLZB{border-radius:50%!important}.eLlLL{border-radius:inherit!important}._3SUWU{pointer-events:none!important}._24GyE{position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1px;width:1px;margin:-1px;padding:0;border:0}";
var globalStyles = {"align-items-flex-start":"_2CrqF","align-items-center":"_1EGEZ","align-items-flex-end":"hfS2F","justify-content-flex-start":"_3VvAP","justify-content-center":"_2_6C7","justify-content-flex-end":"_28Jsi","justify-content-space-between":"Dvqra","flex-grow-0":"_2G1nr","flex-grow-1":"_1Ji62","flex-shrink-0":"_2PPBa","flex-shrink-1":"_2GGyF","padding-top-2xs":"_35-AQ","padding-top-xs":"_3RPRq","padding-top-s":"_1pEbe","padding-top-m":"_23W76","padding-top-l":"_1Jgne","padding-top-xl":"_3jC8l","padding-top-2xl":"_2nRV-","padding-right-2xs":"_2lnbD","padding-right-xs":"_2rQlz","padding-right-s":"OUTnI","padding-right-m":"_2ulSe","padding-right-l":"_1rxy2","padding-right-xl":"Utljf","padding-right-2xl":"_2CtgS","padding-bottom-2xs":"sy1Dh","padding-bottom-xs":"_3T1we","padding-bottom-s":"_2vM-g","padding-bottom-m":"uWtMV","padding-bottom-l":"mXIFD","padding-bottom-xl":"_29SIx","padding-bottom-2xl":"_2uDY","padding-left-2xs":"EozXW","padding-left-xs":"G1rfC","padding-left-s":"_539Q6","padding-left-m":"VyH4H","padding-left-l":"_3bL4m","padding-left-xl":"_1s5SS","padding-left-2xl":"_5-zEv","padding-2xs":"_2kg14","padding-xs":"_1wTNV","padding-s":"_2JwXf","padding-m":"eatEE","padding-l":"NdOVG","padding-xl":"_dQqM","padding-2xl":"_1N-3h","is-rounded":"_3sx6H","is-circled":"_SLZB","inherit-border-radius":"eLlLL","is-inaccessible":"_3SUWU","is-visuallyhidden":"_24GyE"};
styleInject(css_248z);

var globalClasses = (function (cssProps) {
  var _ref;

  if (Object.prototype.toString.call(cssProps) !== '[object Object]') {
    /* eslint-disable-next-line no-console */
    console.error('`cssProps` is not Object');
  }

  var flexGrow = cssProps.flexGrow,
      flexShrink = cssProps.flexShrink,
      alignItems = cssProps.alignItems,
      justifyContent = cssProps.justifyContent,
      padding = cssProps.padding,
      paddingTop = cssProps.paddingTop,
      paddingRight = cssProps.paddingRight,
      paddingBottom = cssProps.paddingBottom,
      paddingLeft = cssProps.paddingLeft,
      margin = cssProps.margin,
      marginTop = cssProps.marginTop,
      marginRight = cssProps.marginRight,
      marginBottom = cssProps.marginBottom,
      marginLeft = cssProps.marginLeft,
      circled = cssProps.circled,
      rounded = cssProps.rounded,
      inaccessible = cssProps.inaccessible,
      inheritBorderRadius = cssProps.inheritBorderRadius;
  return _ref = {}, _defineProperty(_ref, globalStyles["flex-grow-".concat(flexGrow)], flexGrow), _defineProperty(_ref, globalStyles["flex-shrink-".concat(flexShrink)], flexShrink), _defineProperty(_ref, globalStyles["align-items-".concat(alignItems)], alignItems), _defineProperty(_ref, globalStyles["justify-content-".concat(justifyContent)], justifyContent), _defineProperty(_ref, globalStyles["padding-".concat(padding)], padding), _defineProperty(_ref, globalStyles["padding-top-".concat(paddingTop)], paddingTop), _defineProperty(_ref, globalStyles["padding-right-".concat(paddingRight)], paddingRight), _defineProperty(_ref, globalStyles["padding-bottom-".concat(paddingBottom)], paddingBottom), _defineProperty(_ref, globalStyles["padding-left-".concat(paddingLeft)], paddingLeft), _defineProperty(_ref, globalStyles["margin-".concat(margin)], margin), _defineProperty(_ref, globalStyles["margin-top-".concat(marginTop)], marginTop), _defineProperty(_ref, globalStyles["margin-right-".concat(marginRight)], marginRight), _defineProperty(_ref, globalStyles["margin-bottom-".concat(marginBottom)], marginBottom), _defineProperty(_ref, globalStyles["margin-left-".concat(marginLeft)], marginLeft), _defineProperty(_ref, globalStyles['is-circled'], circled), _defineProperty(_ref, globalStyles['is-rounded'], rounded), _defineProperty(_ref, globalStyles['is-inaccessible'], inaccessible), _defineProperty(_ref, globalStyles['inherit-border-radius'], inheritBorderRadius), _ref;
});

var StyledPage = function StyledPage(_ref) {
  var _cx;

  var children = _ref.children,
      css = _ref.css,
      pageNumber = _ref.pageNumber,
      pageWidth = _ref.pageWidth,
      pageHeight = _ref.pageHeight,
      cmpLoading = _ref.cmpLoading,
      cmpRendered = _ref.cmpRendered,
      cmpNoData = _ref.cmpNoData,
      cmpError = _ref.cmpError,
      zoom = _ref.zoom,
      _onRenderSuccess = _ref.onRenderSuccess,
      onLoadError = _ref.onLoadError;
  var behavior = css.behavior,
      maxWidth = css.maxWidth,
      maxHeight = css.maxHeight,
      rounded = css.rounded,
      circled = css.circled,
      width = css.width,
      height = css.height,
      inheritBorderRadius = css.inheritBorderRadius;
  var componentClassName = classNames(StylesMedia.media, (_cx = {}, _defineProperty(_cx, StylesMedia["width--".concat(width)], width), _defineProperty(_cx, StylesMedia["height--".concat(height)], height), _defineProperty(_cx, StylesMedia["max-width--".concat(maxWidth)], maxWidth), _defineProperty(_cx, StylesMedia["max-height--".concat(maxHeight)], maxHeight), _defineProperty(_cx, StylesMedia["behavior--".concat(behavior)], behavior), _cx), globalClasses({
    rounded: rounded,
    circled: circled,
    inheritBorderRadius: inheritBorderRadius
  }));
  return /*#__PURE__*/React.createElement(Page, {
    pageNumber: pageNumber,
    width: pageWidth,
    height: pageHeight,
    canvasClassName: StylesMedia.media__item,
    className: componentClassName,
    cmpLoading: cmpLoading,
    cmpNoData: cmpNoData,
    cmpError: cmpError,
    cmpRendered: cmpRendered,
    zoom: zoom,
    onRenderSuccess: function onRenderSuccess() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _onRenderSuccess.apply(void 0, [pageNumber].concat(args));
    },
    onLoadError: onLoadError
  }, children);
};

StyledPage.defaultProps = {
  children: null,
  pageNumber: null,
  pageWidth: null,
  pageHeight: null,
  css: {
    behavior: null,
    circled: false,
    height: null,
    inheritBorderRadius: false,
    maxHeight: null,
    maxWidth: null,
    rounded: false,
    width: null
  },
  cmpLoading: null,
  cmpNoData: null,
  cmpRendered: null,
  cmpError: /*#__PURE__*/React.createElement(ThumbnailBroken, null),
  zoom: 1,
  onRenderSuccess: function onRenderSuccess() {},
  onLoadError: function onLoadError() {}
};

var LIST_PAGE_LABEL = constants.LIST_PAGE_LABEL,
    LOADING_TEXT = constants.LOADING_TEXT,
    EXCLUDED_PAGE_THUMBNAIL_TEXT = constants.EXCLUDED_PAGE_THUMBNAIL_TEXT;
var INTERVAL_DELAY = 200;
var SCALE_EMPTY_PAGE = 0.7; // A4-297x210 (210/297=0.7)

var PageThumbnail = /*#__PURE__*/function (_Component) {
  _inherits(PageThumbnail, _Component);

  var _super = _createSuper(PageThumbnail);

  function PageThumbnail(props) {
    var _this;

    _classCallCheck(this, PageThumbnail);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handlerVisibleChange", function (isVisible) {
      var visible = _this.state.visible;

      if (isVisible && !visible) {
        _this.setState({
          visible: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlerCheck", function (e) {
      var _this$props = _this.props,
          pageNumber = _this$props.pageNumber,
          checked = _this$props.checked,
          onChange = _this$props.onChange;
      onChange(pageNumber, !checked, e);
    });

    _defineProperty(_assertThisInitialized(_this), "handlerRenderSuccess", function () {
      var onRenderSuccess = _this.props.onRenderSuccess;

      _this.setState({
        busy: false,
        error: false
      });

      onRenderSuccess();
    });

    _defineProperty(_assertThisInitialized(_this), "handlerLoadError", function () {
      _this.setState({
        error: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getEmptyPage", function (_ref) {
      var pageWidth = _ref.pageWidth,
          pageHeight = _ref.pageHeight;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: pageWidth === pageHeight ? pageWidth * SCALE_EMPTY_PAGE : pageWidth,
          height: pageHeight
        }
      });
    });

    _this.state = {
      visible: false,
      busy: true,
      error: false
    };
    return _this;
  }

  _createClass(PageThumbnail, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          theme = _this$props2.theme,
          pageNumber = _this$props2.pageNumber,
          pageWidth = _this$props2.pageWidth,
          pageHeight = _this$props2.pageHeight,
          selectable = _this$props2.selectable,
          calculable = _this$props2.calculable,
          checked = _this$props2.checked;
      var _this$state = this.state,
          visible = _this$state.visible,
          busy = _this$state.busy,
          error = _this$state.error;
      var emptyPage = this.getEmptyPage({
        pageWidth: pageWidth,
        pageHeight: pageHeight
      });
      return /*#__PURE__*/React.createElement(VisibilitySensor, {
        onChange: this.handlerVisibleChange,
        intervalDelay: INTERVAL_DELAY,
        partialVisibility: Boolean(true)
      }, /*#__PURE__*/React.createElement(Thumbnail, {
        busy: busy,
        theme: theme,
        checked: checked,
        topBar: busy ? null : calculable && /*#__PURE__*/React.createElement(ThumbnailCounter, null, /*#__PURE__*/React.createElement(Text, {
          css: {
            fontSize: 's'
          },
          value: pageNumber
        })),
        middleBar: /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ThumbnailLoadingContainer, null, /*#__PURE__*/React.createElement(Text, {
          css: {
            color: 'gray',
            fontSize: 's',
            textAlign: 'center'
          },
          value: !error && "".concat(LOADING_TEXT, "...")
        })), /*#__PURE__*/React.createElement(ThumbnailInactiveContainer, null, /*#__PURE__*/React.createElement(Text, {
          css: {
            fontSize: 'm',
            textAlign: 'center',
            textTransform: 'uppercase'
          },
          value: EXCLUDED_PAGE_THUMBNAIL_TEXT
        }))),
        bottomBar: busy ? null : selectable && /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(Grid.Cell, {
          css: {
            padding: 'm'
          }
        }, /*#__PURE__*/React.createElement(Checkbox, {
          checked: checked,
          theme: theme,
          ariaLabel: "".concat(LIST_PAGE_LABEL, " ").concat(pageNumber),
          onChange: this.handlerCheck
        }))))
      }, visible ? /*#__PURE__*/React.createElement(StyledPage, {
        pageNumber: pageNumber,
        pageWidth: pageWidth,
        pageHeight: pageHeight,
        cmpLoading: emptyPage,
        onRenderSuccess: this.handlerRenderSuccess,
        onLoadError: this.handlerLoadError
      }) : emptyPage));
    }
  }]);

  return PageThumbnail;
}(Component);

PageThumbnail.defaultProps = {
  theme: 'primary',
  pageNumber: null,
  checked: true,
  selectable: false,
  calculable: false,
  onChange: function onChange() {},
  onRenderSuccess: function onRenderSuccess() {}
};

var PdfPageList = /*#__PURE__*/function (_Component) {
  _inherits(PdfPageList, _Component);

  var _super = _createSuper(PdfPageList);

  function PdfPageList() {
    var _this;

    _classCallCheck(this, PdfPageList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      documentId: null,
      itemsDiff: 0
    });

    _defineProperty(_assertThisInitialized(_this), "supportGridBrowser", function () {
      return typeof document.querySelector('html').style.grid === 'string';
    });

    _defineProperty(_assertThisInitialized(_this), "handlerRenderItem", function () {
      if (_this.supportGridBrowser()) {
        return;
      }

      var _this$props = _this.props,
          selectedPages = _this$props.selectedPages,
          currentDocumentId = _this$props.documentId;
      var documentId = _this.state.documentId;

      if (currentDocumentId === documentId) {
        return;
      }

      var listWidth = _this.listRef.childNodes[0].clientWidth;
      var item = _this.listRef.childNodes[0].childNodes[0];
      var cntItemInLine = Math.round(listWidth / item.clientWidth);
      var itemsDiff = cntItemInLine - selectedPages.length % cntItemInLine;

      _this.setState({
        documentId: currentDocumentId,
        itemsDiff: itemsDiff
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setListRef", function (el) {
      if (el) {
        _this.listRef = el;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getUniqKey", function (index) {
      var documentId = _this.props.documentId;
      return "page_".concat(documentId, "_").concat(index);
    });

    _defineProperty(_assertThisInitialized(_this), "addEmptyItem", function (list) {
      if (_this.supportGridBrowser()) {
        return;
      }

      var currentDocumentId = _this.props.documentId;
      var _this$state = _this.state,
          documentId = _this$state.documentId,
          itemsDiff = _this$state.itemsDiff;

      if (currentDocumentId !== documentId) {
        var countEmptyPage = 2;

        for (var i = 1; i <= countEmptyPage; i++) {
          list.push( /*#__PURE__*/React.createElement(PageListItem, {
            key: _this.getUniqKey(list.length + i)
          }));
        }

        return;
      }

      for (var _i = 1; _i <= itemsDiff; _i++) {
        list.push( /*#__PURE__*/React.createElement(PageListItem, {
          key: _this.getUniqKey(list.length + _i)
        }));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getListItems", function () {
      var numPages = _this.props.numPages;

      if (numPages === 0) {
        return null;
      }

      var _this$props2 = _this.props,
          selectable = _this$props2.selectable,
          calculable = _this$props2.calculable,
          pageWidth = _this$props2.pageWidth,
          pageHeight = _this$props2.pageHeight,
          selectedPages = _this$props2.selectedPages,
          onClickListItem = _this$props2.onClickListItem;
      var listPage = [];

      for (var i = 1; i <= numPages; i++) {
        listPage.push( /*#__PURE__*/React.createElement(PageListItem, {
          key: _this.getUniqKey(i)
        }, /*#__PURE__*/React.createElement(PageThumbnail, {
          pageNumber: i,
          pageWidth: pageWidth,
          pageHeight: pageHeight,
          selectable: selectable,
          calculable: calculable,
          checked: selectedPages.indexOf(i) >= 0,
          onChange: onClickListItem,
          onRenderSuccess: _this.handlerRenderItem
        })));
      }

      _this.addEmptyItem(listPage);

      return listPage;
    });

    return _this;
  }

  _createClass(PdfPageList, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(PageListLayout, {
        listRef: this.setListRef
      }, this.getListItems());
    }
  }]);

  return PdfPageList;
}(Component);

PdfPageList.defaultProps = {
  documentId: null,
  calculable: true,
  selectable: true,
  numPages: 0,
  selectedPages: [],
  onClickListItem: function onClickListItem() {}
};

var PdfPageListError = function PdfPageListError() {
  return /*#__PURE__*/React.createElement(PageListLayout, null, /*#__PURE__*/React.createElement(PageListItem, null, /*#__PURE__*/React.createElement(ThumbnailBroken, null)));
};

var scale = 4 / 3;

var DocumentIcon = icons.DocumentIcon;
var NO_ONE_SELECTED_PAGE_TEXT = constants.NO_ONE_SELECTED_PAGE_TEXT;

var PreviewPageEmpty = function PreviewPageEmpty(_ref) {
  var css = _ref.css;
  var theme = css.theme;
  return /*#__PURE__*/React.createElement(PreviewLayout, {
    css: {
      theme: theme,
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2xl'
    },
    empty: Boolean(true)
  }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Grid.Row, {
    css: {
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(Grid.Cell, {
    css: {
      paddingTop: 'm',
      paddingBottom: 'm',
      paddingLeft: 'l',
      paddingRight: 'l'
    }
  }, /*#__PURE__*/React.createElement(DocumentIcon, {
    css: {
      height: 'xl',
      width: 'xl'
    }
  }))), /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(Grid.Cell, {
    css: {
      paddingTop: 'm',
      paddingBottom: 'm',
      paddingLeft: 'l',
      paddingRight: 'l'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    css: {
      color: 'gray',
      fontSize: 'xl',
      textAlign: 'center'
    },
    value: NO_ONE_SELECTED_PAGE_TEXT
  })))));
};

PreviewPageEmpty.defaultProps = {
  css: {
    theme: 'primary',
    justifyContent: 'center',
    padding: '2xl'
  }
};

var Hint = function Hint(_ref) {
  var enabled = _ref.enabled,
      visible = _ref.visible,
      Content = _ref.Content;
  return enabled && /*#__PURE__*/React.createElement("div", {
    className: classNames('pdf-viewer-hint', {
      'pdf-viewer-hint--visible': visible
    })
  }, Content && /*#__PURE__*/React.createElement(Content, null), /*#__PURE__*/React.createElement("div", {
    className: classNames('pdf-viewer-hint__arrow')
  }));
};

Hint.defaultProps = {
  enabled: false,
  visible: true,
  Content: function Content() {
    return 'Content';
  }
};

var FieldElement = React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      name = _ref.name,
      type = _ref.type,
      focused = _ref.focused,
      required = _ref.required,
      disabled = _ref.disabled,
      value = _ref.value,
      readOnly = _ref.readOnly,
      autoFocus = _ref.autoFocus,
      height = _ref.height,
      width = _ref.width,
      x = _ref.x,
      y = _ref.y,
      fontFamily = _ref.fontFamily,
      fontSize = _ref.fontSize,
      onChange = _ref.onChange,
      hint = _ref.hint,
      onKeyDown = _ref.onKeyDown;

  var onInputChange = function onInputChange(event) {
    var target = event.target;
    var fieldValue = target.type === 'checkbox' ? target.checked : target.value;
    onChange({
      id: id,
      fieldName: target.name,
      fieldValue: fieldValue
    });
  };

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      hintVisible = _useState2[0],
      setHintVisible = _useState2[1];

  var text = function text() {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'absolute',
        top: "".concat(y, "px"),
        left: "".concat(x, "px"),
        height: "".concat(height, "px"),
        width: "".concat(width, "px"),
        display: 'flex',
        fontSize: "".concat(fontSize, "px")
      }
    }, /*#__PURE__*/React.createElement(Input, {
      id: id,
      name: name,
      css: {
        theme: 'transparent-orange',
        width: '100pct',
        height: '100pct',
        fontFamily: fontFamily.toLowerCase()
      },
      focused: focused,
      required: required && !value,
      value: value,
      disabled: disabled,
      readonly: readOnly,
      autoFocus: autoFocus,
      onKeyDown: onKeyDown,
      onChange: onInputChange,
      onFocus: function onFocus() {
        return setHintVisible(false);
      },
      onBlur: function onBlur() {
        return setHintVisible(true);
      },
      ref: ref
    }), hint && /*#__PURE__*/React.createElement(Hint, _extends({}, hint, {
      visible: hintVisible
    })));
  };

  var checkmark = function checkmark() {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'absolute',
        top: "".concat(y, "px"),
        left: "".concat(x, "px"),
        height: "".concat(height, "px"),
        width: "".concat(width, "px"),
        fontSize: "".concat(width, "px")
      }
    }, /*#__PURE__*/React.createElement(Checkbox$1, {
      id: id,
      name: name,
      css: {
        theme: 'transparent-orange'
      },
      checked: value,
      required: required,
      disabled: disabled,
      onChange: !readOnly && onInputChange,
      onKeyDown: onKeyDown,
      ref: ref
    }));
  };

  switch (type) {
    case 'text':
      return text();

    case 'checkmark':
      return checkmark();

    default:
      return text();
  }
});
FieldElement.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  css: PropTypes.shape({
    theme: PropTypes.oneOf(['primary'])
  }),
  focused: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  type: PropTypes.oneOf(['text', 'signature', 'checkmark']),
  // subType: PropTypes.oneOf(['none', 'subType']),
  width: PropTypes.number.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  fontSize: PropTypes.number,
  fontFamily: PropTypes.string,
  readOnly: PropTypes.bool,
  autoFocus: PropTypes.bool,
  hint: PropTypes.shape(Hint.propTypes),
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func
};
FieldElement.defaultProps = {
  focused: false,
  required: false,
  type: 'text',
  disabled: false,
  value: '',
  css: {
    theme: 'primary'
  },
  readOnly: true,
  autoFocus: false,
  fontSize: 9,
  fontFamily: 'arial',
  hint: {
    enabled: false
  },
  onChange: function onChange() {},
  onKeyDown: function onKeyDown() {}
};

var FieldLayer = /*#__PURE__*/function (_Component) {
  _inherits(FieldLayer, _Component);

  var _super = _createSuper(FieldLayer);

  function FieldLayer(props) {
    var _this;

    _classCallCheck(this, FieldLayer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleResizing", function () {
      var renderedCanvas = _this.state.renderedCanvas;
      var canvasNode = _this.props.canvasNode;

      if (canvasNode.clientWidth !== renderedCanvas.currentWidth) {
        _this.setState({
          resizing: true
        });

        clearTimeout(_this.timer);
        _this.timer = setTimeout(function () {
          _this.setState({
            resizing: false
          });
        }, 200);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "subscribeEvents", function () {
      var resizing = _this.state.resizing;
      _this.resizeSubscription = throttle(function () {
        _this.handleResizing();

        if (!resizing) {
          _this.updateCanvasState();

          _this.updatePageScale();
        }
      }, 100);
      window.addEventListener('resize', _this.resizeSubscription, false);
    });

    _defineProperty(_assertThisInitialized(_this), "unsubscribeEvents", function () {
      window.removeEventListener('resize', _this.resizeSubscription, false);
    });

    _defineProperty(_assertThisInitialized(_this), "updateCanvasState", function () {
      var canvasNode = _this.props.canvasNode;

      _this.setState({
        renderedCanvas: {
          currentHeight: canvasNode.clientHeight,
          currentWidth: canvasNode.clientWidth
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updatePageScale", function () {
      var renderedCanvas = _this.state.renderedCanvas;
      var newScale = renderedCanvas.currentWidth / _this.defaultCanvasSize.width;

      _this.setState({
        scale: newScale
      }, function () {
        document.documentElement.style.setProperty('--field-layer-scale', newScale);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectField", function (item) {
      var selectedFields = _this.props.selectedFields;

      if (selectedFields) {
        if (Array.isArray(selectedFields)) {
          return selectedFields.includes(item.id) || selectedFields.includes(item.name);
        }

        return selectedFields === item.id || selectedFields === item.name;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "handlerKeyDown", function (event, index) {
      var inputRefs = _this.state.inputRefs;

      if (event.key === 'Enter') {
        event.preventDefault();
        var nextField = inputRefs[index + 1];

        if (nextField && nextField.current) {
          nextField.current.focus();
        }
      }
    });

    var _canvasNode = props.canvasNode,
        scale = props.scale,
        defaultScale = props.defaultScale,
        defaultWidth = props.defaultWidth,
        defaultHeight = props.defaultHeight; // defaultScale / scale - calculate current page scale

    var currentScale = scale ? defaultScale / scale : defaultScale;
    _this.defaultCanvasSize = {
      width: defaultWidth * currentScale,
      height: defaultHeight * currentScale
    };
    _this.state = {
      resizing: false,
      scale: 1,
      renderedCanvas: {
        currentWidth: _canvasNode.clientWidth,
        currentHeight: _canvasNode.clientHeight
      },
      inputRefs: []
    };
    _this.resizeSubscription = null;
    _this.timer = null;
    return _this;
  }

  _createClass(FieldLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updatePageScale();
      this.subscribeEvents();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unsubscribeEvents();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          scale = _this$state.scale,
          resizing = _this$state.resizing,
          inputRefs = _this$state.inputRefs;
      var _this$defaultCanvasSi = this.defaultCanvasSize,
          width = _this$defaultCanvasSi.width,
          height = _this$defaultCanvasSi.height;
      var _this$props = this.props,
          pageFieldsData = _this$props.pageFieldsData,
          onChange = _this$props.onChange;
      return /*#__PURE__*/React.createElement(FieldLayerLayout, {
        hidden: resizing,
        scale: scale,
        width: width,
        height: height
      }, pageFieldsData && pageFieldsData.map(function (item, index) {
        return /*#__PURE__*/React.createElement(FieldElement, {
          key: "input_".concat(item.id, "}"),
          name: item.name,
          id: item.id,
          height: item.height,
          focused: _this2.selectField(item),
          required: item.required,
          locked: item.locked,
          type: item.type,
          subType: item.subType,
          width: item.width,
          x: item.x,
          y: item.y,
          value: item.value,
          fontSize: item.fontSize,
          fontFamily: item.fontFamily,
          readOnly: item.readOnly,
          autoFocus: item.autoFocus,
          onChange: onChange,
          hint: item.hint,
          onKeyDown: function onKeyDown(event) {
            return _this2.handlerKeyDown(event, index);
          },
          ref: inputRefs[index]
        });
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var pageFieldsData = props.pageFieldsData;
      return _objectSpread2({}, state, {
        inputRefs: pageFieldsData.map(function () {
          return React.createRef();
        })
      });
    }
  }]);

  return FieldLayer;
}(Component);

FieldLayer.defaultProps = {
  scale: null,
  defaultScale: 4 / 3,
  // by default, PDFfiller uses scale by default
  selectedFields: null,
  onChange: function onChange() {}
};

var FillablePage = function FillablePage(_ref) {
  var fillableTemplate = _ref.fillableTemplate,
      fillableTemplateScale = _ref.fillableTemplateScale,
      pageNumber = _ref.pageNumber,
      selectedFields = _ref.selectedFields,
      onFillableChange = _ref.onFillableChange,
      _onRenderSuccess = _ref.onRenderSuccess,
      props = _objectWithoutProperties(_ref, ["fillableTemplate", "fillableTemplateScale", "pageNumber", "selectedFields", "onFillableChange", "onRenderSuccess"]);

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  return /*#__PURE__*/React.createElement(StyledPage, _extends({
    pageNumber: pageNumber
  }, props, {
    onRenderSuccess: function onRenderSuccess(renderPageNumber, w, h, canvas, scale) {
      _onRenderSuccess(renderPageNumber, w, h, canvas, scale);

      setState({
        width: w,
        height: h,
        canvas: canvas,
        scale: scale,
        renderPageNumber: renderPageNumber
      });
    }
  }), fillableTemplate && state.renderPageNumber === pageNumber && state.canvas && /*#__PURE__*/React.createElement(FieldLayer, {
    defaultScale: fillableTemplateScale,
    defaultWidth: state.width,
    defaultHeight: state.height,
    scale: state.scale,
    canvasNode: state.canvas,
    pageFieldsData: fillableTemplate,
    selectedFields: selectedFields,
    onChange: onFillableChange
  }));
};

FillablePage.defaultProps = _objectSpread2({
  fillableTemplate: null,
  fillableTemplateScale: scale,
  selectedFields: null,
  onFillableChange: function onFillableChange() {},
  onRenderSuccess: function onRenderSuccess() {}
}, StyledPage.defaultProps);

var PreviewPage = function PreviewPage(_ref) {
  var css = _ref.css,
      empty = _ref.empty,
      controlBar = _ref.controlBar,
      props = _objectWithoutProperties(_ref, ["css", "empty", "controlBar"]);

  return empty ? /*#__PURE__*/React.createElement(PreviewPageEmpty, null) : /*#__PURE__*/React.createElement(PreviewLayout, {
    css: css,
    controlBar: controlBar
  }, /*#__PURE__*/React.createElement(FillablePage, _extends({
    css: {
      behavior: 'contain-proportionally'
    }
  }, props)));
};

PreviewPage.defaultProps = {
  cmpLoading: null,
  cmpRendered: null,
  css: {
    padding: '2xl',
    theme: 'primary'
  },
  empty: false,
  pageNumber: null,
  pageWidth: null,
  pageHeight: null,
  fillableTemplate: null,
  selectedFields: null,
  fillableTemplateScale: scale,
  onFillableChange: function onFillableChange() {}
};

var DocumentIcon$1 = icons.DocumentIcon;
var NOT_AVAILABLE_PAGE_PREVIEW_TEXT = constants.NOT_AVAILABLE_PAGE_PREVIEW_TEXT;

var NoPdfPagePreview = function NoPdfPagePreview(_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/React.createElement(PreviewLayout, {
    css: {
      theme: theme,
      justifyContent: 'center',
      padding: '2xl',
      alignItems: 'center'
    },
    empty: Boolean(true)
  }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Grid.Row, {
    css: {
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(Grid.Cell, {
    css: {
      paddingTop: 'm',
      paddingBottom: 'm',
      paddingLeft: 'l',
      paddingRight: 'l'
    }
  }, /*#__PURE__*/React.createElement(DocumentIcon$1, {
    css: {
      height: 'xl',
      width: 'xl'
    }
  }))), /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(Grid.Cell, {
    css: {
      paddingTop: 'm',
      paddingBottom: 'm',
      paddingLeft: 'l',
      paddingRight: 'l'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    css: {
      color: 'gray',
      fontSize: 'xl',
      textAlign: 'center'
    },
    value: NOT_AVAILABLE_PAGE_PREVIEW_TEXT
  })))));
};

NoPdfPagePreview.defaultProps = {
  theme: 'primary'
};

var LocalStorage = function LocalStorage() {
  var _this = this;

  _classCallCheck(this, LocalStorage);

  _defineProperty(this, "isLocalStorage", function () {
    return !!localStorage;
  });

  _defineProperty(this, "setItem", function (itemName, value) {
    if (_this.isLocalStorage()) {
      localStorage.setItem(itemName, value);
    }
  });

  _defineProperty(this, "getItem", function (itemName) {
    return _this.isLocalStorage() ? localStorage.getItem(itemName) : null;
  });

  _defineProperty(this, "removeItem", function (itemName) {
    if (_this.isLocalStorage()) {
      localStorage.removeItem(itemName);
    }
  });
};

var localStorage$1 = new LocalStorage();
var PdfPageSmallPreviewInternal = function PdfPageSmallPreviewInternal(_ref) {
  var url = _ref.url,
      projectId = _ref.projectId,
      pageNumber = _ref.pageNumber,
      width = _ref.width,
      height = _ref.height,
      componentClassName = _ref.componentClassName,
      cmpLoading = _ref.cmpLoading,
      cmpNoData = _ref.cmpNoData,
      onRenderSuccess = _ref.onRenderSuccess,
      onDocumentLoadSuccess = _ref.onDocumentLoadSuccess;

  var handlerRenderSuccess = function handlerRenderSuccess(w, h, canvas) {
    localStorage$1.setItem(projectId, canvas.toDataURL());
    localStorage$1.setItem("".concat(projectId, "width"), parseInt(w, 10));
    localStorage$1.setItem("".concat(projectId, "height"), parseInt(h, 10));
    onRenderSuccess(pageNumber, w, h);
  };

  var renderImgCanvas = function renderImgCanvas(img) {
    var w = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : width;
    var h = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : height;

    var elRef = function elRef(canvas) {
      if (canvas) {
        var ctx = canvas.getContext('2d');
        var newImage = new Image();

        newImage.onload = function () {
          return ctx.drawImage(newImage, 0, 0);
        };

        newImage.src = img;
      }
    };

    return /*#__PURE__*/React.createElement("div", {
      className: componentClassName,
      "data-page-number": pageNumber
    }, /*#__PURE__*/React.createElement("canvas", {
      width: w,
      height: h,
      ref: elRef
    }));
  };

  var renderDocument = function renderDocument() {
    return /*#__PURE__*/React.createElement(Document, {
      id: projectId,
      url: url,
      cmpLoading: cmpLoading,
      cmpNoData: cmpNoData,
      onLoadSuccess: onDocumentLoadSuccess
    }, /*#__PURE__*/React.createElement(Page, {
      pageNumber: pageNumber,
      width: width,
      height: height,
      canvasClassName: componentClassName,
      cmpLoading: cmpLoading,
      cmpNoData: cmpNoData,
      onRenderSuccess: handlerRenderSuccess
    }));
  };

  var getPage = function getPage() {
    var img = localStorage$1.getItem(projectId);
    return img ? renderImgCanvas(img, localStorage$1.getItem("".concat(projectId, "width")), localStorage$1.getItem("".concat(projectId, "height"))) : renderDocument();
  };

  return getPage();
};
PdfPageSmallPreviewInternal.defaultProps = {
  url: null,
  pageNumber: 1,
  width: 34,
  height: 44,
  componentClassName: null,
  cmpLoading: /*#__PURE__*/React.createElement(ProgressBar, null, /*#__PURE__*/React.createElement(InfiniteProgress, null)),
  cmpNoData: /*#__PURE__*/React.createElement(ProgressBar, null, /*#__PURE__*/React.createElement(InfiniteProgress, null)),
  onDocumentLoadSuccess: function onDocumentLoadSuccess() {},
  onRenderSuccess: function onRenderSuccess() {}
};

var PdfPageSmallPreview = function PdfPageSmallPreview(props) {
  return /*#__PURE__*/React.createElement(Documents, null, /*#__PURE__*/React.createElement(PdfPageSmallPreviewInternal, props));
};

var PREVIOUS_PAGE_CONTROL_TEXT = constants.PREVIOUS_PAGE_CONTROL_TEXT,
    EDIT_PAGE_CONTROL_TEXT = constants.EDIT_PAGE_CONTROL_TEXT,
    NEXT_PAGE_CONTROL_TEXT = constants.NEXT_PAGE_CONTROL_TEXT;
var PreviousIcon = icons.PreviousIcon,
    NextIcon = icons.NextIcon;
var targetId = {
  PREVIOUS_PAGE: 'previousControl',
  EDIT_PAGE: 'editPageControl',
  NEXT_PAGE: 'nextControl'
};

var PdfPageControlBar = function PdfPageControlBar(_ref) {
  var _onClick = _ref.onClick,
      disabledPrevious = _ref.disabledPrevious,
      disabledNext = _ref.disabledNext,
      disabledEdit = _ref.disabledEdit,
      showPrevious = _ref.showPrevious,
      showNext = _ref.showNext,
      showEdit = _ref.showEdit;
  return /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Grid.Row, {
    css: {
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, showPrevious && /*#__PURE__*/React.createElement(Grid.Cell, {
    css: {
      paddingLeft: 'xs',
      paddingRight: 'xs'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    css: {
      circled: true,
      theme: 'dark-gray',
      width: 'm',
      minHeight: 'm'
    },
    ariaLabel: PREVIOUS_PAGE_CONTROL_TEXT,
    disabled: disabledPrevious,
    onClick: function onClick(e) {
      return _onClick(targetId.PREVIOUS_PAGE, e);
    }
  }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(PreviousIcon, {
    css: {
      width: 'xs',
      height: 'xs'
    }
  })))))), showEdit && /*#__PURE__*/React.createElement(Grid.Cell, {
    css: {
      paddingLeft: 'xs',
      paddingRight: 'xs'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    css: {
      rounded: true,
      theme: 'dark-gray',
      minHeight: 'm',
      paddingLeft: '2xl',
      paddingRight: '2xl'
    },
    disabled: disabledEdit,
    onClick: function onClick(e) {
      return _onClick(targetId.EDIT_PAGE, e);
    }
  }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(Grid.Cell, {
    css: {
      paddingLeft: 'xs',
      paddingRight: 'xs'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    css: {
      whiteSpace: 'nowrap'
    },
    value: EDIT_PAGE_CONTROL_TEXT
  })))))), showNext && /*#__PURE__*/React.createElement(Grid.Cell, {
    css: {
      paddingLeft: 'xs',
      paddingRight: 'xs'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    css: {
      circled: true,
      theme: 'dark-gray',
      width: 'm',
      minHeight: 'm'
    },
    ariaLabel: NEXT_PAGE_CONTROL_TEXT,
    disabled: disabledNext,
    onClick: function onClick(e) {
      return _onClick(targetId.NEXT_PAGE, e);
    }
  }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(NextIcon, {
    css: {
      width: 'xs',
      height: 'xs'
    }
  }))))))));
};

PdfPageControlBar.defaultProps = {
  disabledPrevious: true,
  disabledNext: true,
  disabledEdit: true,
  showPrevious: true,
  showNext: true,
  showEdit: false,
  onClick: function onClick() {}
};
PdfPageControlBar.targetId = targetId;

var prepareFillableTemplate = (function (_ref) {
  var template = _ref.template,
      fieldsValue = _ref.fieldsValue;

  if (!template) {
    return false;
  }

  var defaultPDFfillerScale = scale;
  var defaultAirSlateScale = 1;

  var matchValueByFieldId = function matchValueByFieldId(templateData) {
    if (!fieldsValue) {
      return templateData;
    }

    var values = fieldsValue.reduce(function (curr, item) {
      return _objectSpread2({}, curr, _defineProperty({}, item.id, {
        value: item.value,
        readOnly: item.readOnly
      }));
    }, {});
    var IDs = Object.keys(values);
    return templateData.map(function (page) {
      return page && page.map(function (field) {
        if (!field || !field.id) {
          return field;
        }

        return IDs.includes(String(field.id)) ? _objectSpread2({}, field, {}, values[field.id]) : field;
      });
    });
  };

  if (template.data) {
    return {
      fields: matchValueByFieldId(template.data),
      scale: defaultPDFfillerScale
    };
  }

  if (template.fields) {
    if (!template.fields.list) {
      return false;
    }

    return {
      fields: matchValueByFieldId(Object.keys(template.fields.list).reduce(function (result, item) {
        var values = Object.values(template.fields.list[item]);
        return [].concat(_toConsumableArray(result), [values.length !== 0 ? values : null]);
      }, [])),
      scale: defaultAirSlateScale
    };
  }

  return template;
});

/**
 * @visibleName PdfPageViewer
 */

var PdfPageViewerInternal = /*#__PURE__*/function (_Component) {
  _inherits(PdfPageViewerInternal, _Component);

  var _super = _createSuper(PdfPageViewerInternal);

  function PdfPageViewerInternal(props) {
    var _this;

    _classCallCheck(this, PdfPageViewerInternal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setPageNumber", function (_ref) {
      var documentId = _ref.documentId,
          pageNumber = _ref.pageNumber;
      var documents = _this.state.documents;
      var document = documents[documentId];

      if (!document) {
        return;
      }

      _this.setState({
        documents: _objectSpread2({}, documents, _defineProperty({}, documentId, _objectSpread2({}, document, {
          pageNumber: pageNumber
        })))
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handlerDocumentLoadSuccess", function (id, _ref2) {
      var numPages = _ref2.numPages;
      var _this$props = _this.props,
          pageNumber = _this$props.pageNumber,
          onLoadSuccess = _this$props.onLoadSuccess;
      var documents = _this.state.documents;
      var document = documents[id];

      _this.setState({
        documents: _objectSpread2({}, documents, _defineProperty({}, id, _objectSpread2({}, document, {
          numPages: numPages,
          pageNumber: pageNumber
        })))
      });

      onLoadSuccess(numPages, id);
    });

    _defineProperty(_assertThisInitialized(_this), "handlerClickActionBar", function (action) {
      var _PdfPageControlBar$ta = PdfPageControlBar.targetId,
          PREVIOUS_PAGE = _PdfPageControlBar$ta.PREVIOUS_PAGE,
          NEXT_PAGE = _PdfPageControlBar$ta.NEXT_PAGE;

      switch (action) {
        case PREVIOUS_PAGE:
          _this.handlerChangePageNumber(-1);

          break;

        case NEXT_PAGE:
          _this.handlerChangePageNumber(1);

          break;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlerChangePageNumber", function (direction) {
      var _this$props2 = _this.props,
          documentId = _this$props2.documentId,
          onClickActionBar = _this$props2.onClickActionBar;
      var documents = _this.state.documents;
      var document = documents[documentId];

      if (!document) {
        return;
      }

      var numPages = document.numPages,
          pageNumber = document.pageNumber;
      var nextPageNumber = pageNumber + direction;
      nextPageNumber = nextPageNumber > numPages || nextPageNumber < 1 ? pageNumber : nextPageNumber;

      if (nextPageNumber === pageNumber) {
        return;
      }

      _this.setState({
        documents: _objectSpread2({}, documents, _defineProperty({}, documentId, _objectSpread2({}, document, {
          pageNumber: nextPageNumber
        })))
      });

      onClickActionBar(nextPageNumber);
    });

    _defineProperty(_assertThisInitialized(_this), "getStatusOfActionButtons", function (documentId) {
      var document = _this.state.documents[documentId];

      if (!document) {
        return {
          disabledNext: true,
          disabledPrevious: true
        };
      }

      var numPages = document.numPages,
          pageNumber = document.pageNumber;
      return {
        disabledNext: pageNumber >= numPages,
        disabledPrevious: pageNumber <= 1
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getPageNumber", function (_ref3) {
      var pageNumber = _ref3.pageNumber,
          documentId = _ref3.documentId;
      var documents = _this.state.documents;
      var document = documents[documentId];

      if (!document) {
        return pageNumber;
      }

      var oldPageNumber = document.pageNumber;
      return oldPageNumber || pageNumber;
    });

    var _documentId = props.documentId,
        _pageNumber = props.pageNumber,
        _documents = props.documents;

    var _numPages = _documents[_documentId] && _documents[_documentId].pdf ? _documents[_documentId].pdf.numPages : 0;

    _this.state = {
      documents: _defineProperty({}, _documentId, {
        pageNumber: _pageNumber,
        numPages: _numPages
      })
    };
    return _this;
  }

  _createClass(PdfPageViewerInternal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var documentId = prevProps.documentId,
          pageNumber = prevProps.pageNumber;
      var currentDocumentId = this.props.documentId;

      if (documentId !== currentDocumentId) {
        this.setPageNumber({
          documentId: documentId,
          pageNumber: pageNumber
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          url = _this$props3.url,
          documentId = _this$props3.documentId,
          pageNumber = _this$props3.pageNumber,
          pageHeight = _this$props3.pageHeight,
          pageWidth = _this$props3.pageWidth,
          cmpNoData = _this$props3.cmpNoData,
          cmpLoading = _this$props3.cmpLoading,
          cmpLoadingPage = _this$props3.cmpLoadingPage,
          cmpRenderedPage = _this$props3.cmpRenderedPage,
          fillableTemplate = _this$props3.fillableTemplate,
          showFillableTemplate = _this$props3.showFillableTemplate,
          showActionBar = _this$props3.showActionBar,
          selectedFields = _this$props3.selectedFields,
          onLoadError = _this$props3.onLoadError,
          onLoadProgress = _this$props3.onLoadProgress,
          onSourceError = _this$props3.onSourceError,
          onSourceSuccess = _this$props3.onSourceSuccess,
          onFillableChange = _this$props3.onFillableChange;

      var _this$getStatusOfActi = this.getStatusOfActionButtons(documentId),
          disabledNext = _this$getStatusOfActi.disabledNext,
          disabledPrevious = _this$getStatusOfActi.disabledPrevious;

      var currentPageNumber = this.getPageNumber({
        pageNumber: pageNumber,
        documentId: documentId
      });

      var _prepareFillableTempl = prepareFillableTemplate(fillableTemplate),
          fillableFields = _prepareFillableTempl.fields,
          fillableTemplateScale = _prepareFillableTempl.scale;

      return /*#__PURE__*/React.createElement(Document, {
        id: documentId,
        url: url,
        cmpNoData: cmpNoData,
        cmpLoading: cmpLoading,
        cmpError: /*#__PURE__*/React.createElement(NoPdfPagePreview, null),
        onLoadError: onLoadError,
        onLoadProgress: onLoadProgress,
        onSourceError: onSourceError,
        onSourceSuccess: onSourceSuccess,
        onLoadSuccess: this.handlerDocumentLoadSuccess
      }, /*#__PURE__*/React.createElement(PreviewPage, {
        onFillableChange: onFillableChange,
        fillableTemplate: showFillableTemplate && fillableFields && fillableFields[currentPageNumber - 1],
        fillableTemplateScale: fillableTemplateScale,
        selectedFields: selectedFields,
        showFillableTemplate: showFillableTemplate,
        pageNumber: currentPageNumber,
        pageWidth: pageWidth,
        pageHeight: pageHeight,
        cmpRendered: cmpRenderedPage,
        cmpLoading: cmpLoadingPage,
        controlBar: showActionBar && (!disabledNext || !disabledPrevious) && /*#__PURE__*/React.createElement(PdfPageControlBar, {
          disabledNext: disabledNext,
          disabledPrevious: disabledPrevious,
          onClick: this.handlerClickActionBar
        })
      }));
    }
  }]);

  return PdfPageViewerInternal;
}(Component);

_defineProperty(PdfPageViewerInternal, "defaultProps", {
  url: null,
  pageNumber: 1,
  pageWidth: null,
  pageHeight: null,
  fillableTemplate: null,
  selectedFields: null,
  cmpLoading: /*#__PURE__*/React.createElement(ProgressBar, null, /*#__PURE__*/React.createElement(UploadingDocumentProgress, {
    css: {
      width: null,
      height: null
    }
  })),
  cmpRenderedPage: /*#__PURE__*/React.createElement(ProgressBar, null, /*#__PURE__*/React.createElement(InfiniteProgress, {
    css: {
      width: 'l',
      height: 'l'
    }
  })),
  cmpLoadingPage: /*#__PURE__*/React.createElement(ProgressBar, null, /*#__PURE__*/React.createElement(InfiniteProgress, {
    css: {
      width: 'l',
      height: 'l'
    }
  })),
  cmpNoData: /*#__PURE__*/React.createElement(ProgressBar, null, /*#__PURE__*/React.createElement(UploadingDocumentProgress, {
    css: {
      width: null,
      height: null
    }
  })),
  showFillableTemplate: true,
  showActionBar: true,
  onClickActionBar: function onClickActionBar() {},
  onLoadError: function onLoadError() {},
  onLoadSuccess: function onLoadSuccess() {},
  onLoadProgress: function onLoadProgress() {},
  onSourceError: function onSourceError() {},
  onSourceSuccess: function onSourceSuccess() {},
  onFillableChange: function onFillableChange() {}
});

var PdfPageViewer = function PdfPageViewer(props) {
  return /*#__PURE__*/React.createElement(DocumentsContext.Consumer, null, function (_ref4) {
    var documents = _ref4.documents;
    return /*#__PURE__*/React.createElement(PdfPageViewerInternal, _extends({}, props, {
      documents: documents
    }));
  });
};

var PagePreviewIcon = icons.PagePreviewIcon,
    StackIcon = icons.StackIcon;
var PREVIEW_CONTROL_TEXT = constants.PREVIEW_CONTROL_TEXT,
    SELECT_PAGES_CONTROL_TEXT = constants.SELECT_PAGES_CONTROL_TEXT;
var PdfViewerInternal = function PdfViewerInternal(_ref) {
  var documentId = _ref.documentId,
      url = _ref.url,
      numPages = _ref.numPages,
      pageNumber = _ref.pageNumber,
      pageWidth = _ref.pageWidth,
      pageHeight = _ref.pageHeight,
      listPageWidth = _ref.listPageWidth,
      listPageHeight = _ref.listPageHeight,
      selectedPages = _ref.selectedPages,
      cmpNoData = _ref.cmpNoData,
      cmpLoading = _ref.cmpLoading,
      onDocumentLoadSuccess = _ref.onDocumentLoadSuccess,
      disabledEdit = _ref.disabledEdit,
      disabledNext = _ref.disabledNext,
      disabledPrevious = _ref.disabledPrevious,
      showPrevious = _ref.showPrevious,
      showNext = _ref.showNext,
      showEdit = _ref.showEdit,
      tabIndex = _ref.tabIndex,
      onClickActionBar = _ref.onClickActionBar,
      onClickListItem = _ref.onClickListItem,
      onChangeTab = _ref.onChangeTab;

  var getCmpByStatus = function getCmpByStatus(status) {
    switch (status) {
      case Document.statuses.NO_DATA:
        // Show default ProgressBar when cmpNoData is null
        return cmpNoData || /*#__PURE__*/React.createElement(ProgressBar, null, /*#__PURE__*/React.createElement(UploadingDocumentProgress, {
          css: {
            width: null,
            height: null
          }
        }));

      case Document.statuses.LOADING:
        return cmpLoading;

      case Document.statuses.FAILED:
        return tabIndex === 0 ? /*#__PURE__*/React.createElement(NoPdfPagePreview, null) : /*#__PURE__*/React.createElement(PdfPageListError, null);

      case Document.statuses.READY:
        return !numPages ? cmpLoading : null;

      default:
        return null;
    }
  };

  return /*#__PURE__*/React.createElement(Document, {
    id: documentId,
    url: url,
    onLoadSuccess: onDocumentLoadSuccess
  }, function (status) {
    return /*#__PURE__*/React.createElement(Tabs, {
      selectedTabIndex: tabIndex,
      onChangeTab: onChangeTab,
      panels: [{
        title: PREVIEW_CONTROL_TEXT,
        icon: /*#__PURE__*/React.createElement(PagePreviewIcon, null),
        render: function render() {
          return getCmpByStatus(status) || /*#__PURE__*/React.createElement(PreviewPage, {
            empty: !selectedPages.length,
            pageNumber: pageNumber,
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            cmpLoading: /*#__PURE__*/React.createElement(ProgressBar, {
              css: {
                theme: 'alabaster'
              }
            }, /*#__PURE__*/React.createElement(InfiniteProgress, {
              css: {
                width: 'l',
                height: 'l'
              }
            })),
            cmpRendered: /*#__PURE__*/React.createElement(ProgressBar, {
              css: {
                theme: 'alabaster'
              }
            }, /*#__PURE__*/React.createElement(InfiniteProgress, {
              css: {
                width: 'l',
                height: 'l'
              }
            })),
            controlBar: /*#__PURE__*/React.createElement(PdfPageControlBar, {
              disabledEdit: disabledEdit,
              disabledNext: disabledNext,
              disabledPrevious: disabledPrevious,
              showPrevious: showPrevious,
              showNext: showNext,
              showEdit: showEdit,
              onClick: onClickActionBar
            })
          });
        }
      }, {
        title: SELECT_PAGES_CONTROL_TEXT,
        icon: /*#__PURE__*/React.createElement(StackIcon, null),
        scrollable: true,
        render: function render() {
          return getCmpByStatus(status) || /*#__PURE__*/React.createElement(PdfPageList, {
            documentId: documentId,
            numPages: numPages,
            pageWidth: listPageWidth,
            pageHeight: listPageHeight,
            selectedPages: selectedPages,
            onClickListItem: onClickListItem
          });
        }
      }]
    });
  });
};
PdfViewerInternal.defaultProps = {
  url: null,
  documentId: null,
  numPages: null,
  pageNumber: null,
  cmpLoading: /*#__PURE__*/React.createElement(ProgressBar, null, /*#__PURE__*/React.createElement(UploadingDocumentProgress, {
    css: {
      width: null,
      height: null
    }
  })),
  cmpNoData: null,
  pageWidth: null,
  pageHeight: null,
  listPageWidth: 180,
  listPageHeight: 180,
  selectedPages: [],
  disabledEdit: true,
  disabledNext: true,
  disabledPrevious: true,
  showPrevious: true,
  showNext: true,
  showEdit: false,
  tabIndex: 0,
  onClickActionBar: function onClickActionBar() {},
  onClickListItem: function onClickListItem() {},
  onChangeTab: function onChangeTab() {},
  onDocumentLoadSuccess: function onDocumentLoadSuccess() {}
};

var PdfViewer = function PdfViewer(props) {
  return /*#__PURE__*/React.createElement(Documents, null, /*#__PURE__*/React.createElement(PdfViewerInternal, props));
};

export { FillablePage, PageThumbnail, PdfPageControlBar, PdfPageList, PdfPageListError, PdfPageSmallPreview, PdfPageViewer, PdfViewer, PreviewPage, NoPdfPagePreview as PreviewPageError };
